import { POI_PACKAGE_STATUS } from 'commons/constants';
import {
  LS_USER_LOADING,
  LS_USER_SUCCESS,
  LS_USER_FAILURE,
  LS_CUSTOMER_LOADING,
  LS_CUSTOMER_SUCCESS,
  LS_CUSTOMER_FAILURE,
  LS_SELECTED_ACCOUNT,
  LS_ACCESS_DATA,
  LS_LOGOUT,
  LS_UPDATE_UNAUTHORIZED_ERROR_MESSAGE,
  LS_RESET_UNAUTHORIZED_ERROR_MESSAGE,
  LS_DELETE_USER_LOADING,
  LS_DELETE_USER_SUCCESS,
  LS_DELETE_USER_FAILURE,
  LS_DELETE_USER_RESET,
} from './newAuthConstants';

const initialState = {
  isLoggedIn: false,
  isUserLoading: true,
  userError: '',
  userData: null,
  isCustomerLoading: true,
  customerError: '',
  customerData: null,
  selectedAccount: null,
  access: {},
  deleteUser: {
    loader: POI_PACKAGE_STATUS.INITIAL,
    error: null,
    data: null,
  },
};

export default function (state, action) {
  state = state || initialState;

  switch (action.type) {
    case LS_USER_LOADING:
      return {
        ...state,
        isUserLoading: true,
        userError: '',
      };

    case LS_USER_SUCCESS:
      return {
        ...state,
        isUserLoading: false,
        userData: action.data,
        userError: '',
      };

    case LS_USER_FAILURE:
      return {
        ...state,
        isUserLoading: false,
        userError: action.error,
      };

    case LS_CUSTOMER_LOADING:
      return {
        ...state,
        isCustomerLoading: true,
        customerError: '',
      };

    case LS_CUSTOMER_SUCCESS:
      return {
        ...state,
        isCustomerLoading: false,
        customerData: action.data,
        customerError: '',
      };

    case LS_CUSTOMER_FAILURE:
      return {
        ...state,
        isCustomerLoading: false,
        customerError: action.error,
      };

    case LS_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.data,
      };

    case LS_ACCESS_DATA:
      return {
        ...state,
        access: { ...state.access, ...action.data },
      };

    case LS_LOGOUT:
      return initialState;

    case LS_UPDATE_UNAUTHORIZED_ERROR_MESSAGE:
      return {
        ...state,
        unAuthorizedErrorMessage: action.data,
      };

    case LS_RESET_UNAUTHORIZED_ERROR_MESSAGE:
      return {
        ...state,
        unAuthorizedErrorMessage: '',
      };

    case LS_DELETE_USER_LOADING:
      return {
        ...state,
        deleteUser: {
          data: action.userData,
          loader: POI_PACKAGE_STATUS.ONGOING,
        },
      };

    case LS_DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUsser,
          data: state.deleteUser.data,
          loader: POI_PACKAGE_STATUS.SUCCESS,
        },
      };

    case LS_DELETE_USER_FAILURE:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUsser,
          error: action.error || null,
          loader: POI_PACKAGE_STATUS.FAILED,
        },
      };
    case LS_DELETE_USER_RESET:
      return {
        ...state,
        deleteUser: {
          ...initialState.deleteUser,
        },
      };
    default:
      return state;
  }
}
